export enum AppCommType{
    POT_MATCH = 'POT_MATCH',
    NEW_MATCH = 'NEW_MATCH',
    SAY_HELLO = 'SAY_HELLO'
}